<template class="full-height">
  <div class="member-container full-height">
    <!-- 審核資料 -->
    <el-dialog
      :top="'5%'"
      v-loading="listLoading"
      :visible.sync="dialogMemberFormVisible"
      :title="`審核-${roleSettingObj.email}`"
      width="80%"
      @close="closeDialog"
    >
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <p>申請時間：{{ roleSettingObj.buildDate }}</p>
          <p>
            email：{{ roleSettingObj.email }}
            <span style="color: #f56c6c">{{ isOk ? '尚未註冊' : '已註冊' }}</span>
          </p>
          <p>姓名：{{ roleSettingObj.name }}</p>
          <p v-if="roleSettingObj.roles !== ''">角色：{{ roleSettingObj.roles }}</p>
          <el-input
            type="textarea"
            :rows="10"
            v-model="roleSettingObj.description"
            disabled
            style="color: black"
          >
          </el-input>

          <p v-if="newp != null && newp !== ''">
            已建立會員資料，預設密碼為<el-tag type="danger" style="margin: 0 4px">{{
              newp
            }}</el-tag>
            請注意，該密碼僅顯示一次，關閉視窗後無法查詢密碼!
          </p>
        </div>

        <el-steps :active="active" finish-status="success">
          <el-step title="步骤 1"></el-step>
          <el-step title="步骤 2"></el-step>
          <el-step title="步骤 3"></el-step>
          <el-step title="步骤 4"></el-step>
        </el-steps>

        <!-- <el-button style="margin-top: 12px" @click="next">下一步</el-button> -->
        <el-alert type="info" :closable="false"
          >請注意，資料為一步一步建立，無返回上一步的操作!</el-alert
        >
        <template v-if="active == 0">
          <p>審核該申請者提交的內容之連結及簡介的正確性後，請點選審核結果進行下一步。</p>
          <el-button type="primary" @click="verify(true)">審核通過</el-button>
          <el-button type="danger" @click="verify(false)">審核不通過</el-button>
        </template>

        <template v-else-if="active == 1">
          <!-- 審核結果通過:該帳號尚未使用則建立帳號及預設密碼 -->
          <template v-if="verifyResult">
            <p v-if="isOk">
              該email尚未建立會員資料，選擇角色後送出將會自動建立會員資料，帳號為email，密碼為預設密碼。
            </p>
            <el-table
              :data="rolesList"
              border
              fit
              highlight-current-row
              style="width: 100%; margin: 20px 0px"
            >
              <el-table-column :label="'選取'">
                <template slot-scope="scope">
                  <el-checkbox v-model="rolesSelected" :label="scope.row.roleCode">
                    選取
                  </el-checkbox>
                </template>
              </el-table-column>

              <el-table-column :label="'角色代碼'">
                <template slot-scope="scope">
                  {{ scope.row.roleCode }}
                </template>
              </el-table-column>

              <el-table-column :label="'角色名稱'">
                <template slot-scope="scope">
                  {{ scope.row.roleName }}
                </template>
              </el-table-column>
            </el-table>
            <el-button type="primary" @click="saveData">確認</el-button>
            <el-button type="danger" @click="closeDialog">取消</el-button>
          </template>
        </template>

        <template v-else-if="active == 2">
          <template v-if="verifyResult">
            <el-alert :closable="false" title="此為向外公開的個人簡介資料" type="warning">
            </el-alert>
            <el-form
              :rules="introRules"
              size="mini"
              ref="introductionForm"
              :model="introObj"
              :label-width="formLabelWidth"
              style="margin: 20px 0px"
            >
              <el-form-item label="頭貼" :label-width="formLabelWidth">
                <div>
                  <Upload
                    ref="uploadRef"
                    :accept="'.jpg,.jpeg,.png'"
                    :payload="introObj"
                    :limit-file-count="1"
                    :limitText="'圖片尺寸:70x70，須為.jpg,.jpeg,.png格式，限制不超過2000MB'"
                    :data-obj="fileObj"
                    :use-drag="false"
                    :action="'ToursCombine/saveIntroAvatar'"
                    :auto-upload="false"
                    :show-file-list="true"
                    :form-on-loading-parent="listLoading"
                    :btn-txt="'上傳'"
                    :before-file-list="
                      introObj.fileInfo && introObj.fileInfo.length
                        ? introObj.fileInfo[0].files
                        : []
                    "
                  />
                </div>
              </el-form-item>

              <el-form-item :label="'名稱'" prop="authorName">
                <el-input v-model="introObj.authorName" maxlength="50" show-word-limit></el-input>
              </el-form-item>

              <el-form-item :label="'簡介'" prop="introduction">
                <el-input
                  type="textarea"
                  v-model="introObj.introduction"
                  :autosize="{ minRows: 4, maxRows: 4 }"
                ></el-input>
              </el-form-item>

              <el-form-item :label="'排序'" prop="sort">
                <el-input v-model="introObj.sort"></el-input>
              </el-form-item>

              <el-form-item
                v-for="(social, index) in introObj.socialLinkList"
                :label="'社群' + (index + 1)"
                :key="index"
                :prop="'social.' + index + '.id'"
              >
                <el-select v-model="social.socialType" placeholder="請選擇">
                  <el-option
                    v-for="item in socialLinkSelectList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input v-model="social.url" style="width: 50%"></el-input>
                <el-button @click.prevent="removeSocialLink(social)">删除</el-button>
              </el-form-item>
              <el-form-item>
                <el-button @click="addSocialLink">新增社群</el-button>
              </el-form-item>
            </el-form>

            <el-button type="primary" @click="saveIntroduction('introductionForm')">確定</el-button>
            <el-button type="danger" @click="closeDialog">取消</el-button>
          </template>
        </template>

        <!-- 審核不通過會直接跳至這，可直接寄信給對方 -->
        <template v-else-if="active == 3">
          <div style="margin: 20px 0px">
            <tinymce ref="tinymce" v-model="emailContent" :height="500" :type="30" />
          </div>
          <el-button type="primary" @click="saveEmail">寄送信件</el-button>
          <el-button type="danger" @click="closeDialog">取消</el-button>
        </template>
      </el-card>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0" class="full-height">
      <div style="padding-bottom: 0">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item label="搜尋">
            <el-input
              size="mini"
              v-model="listQuery.qry"
              placeholder="輸入Email查詢"
              @keyup.enter.native="handleFilter"
            />
          </el-form-item>

          <el-form-item>
            <el-button
              size="mini"
              class="filter-item"
              type="primary"
              icon="el-icon-search"
              @click="handleFilter"
            >
              搜尋
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <div style="position: relative; height: 80%">
        <el-table
          :key="tableKey"
          v-loading="listLoading"
          size="mini"
          :data="list"
          border
          fit
          highlight-current-row
          height="100%"
          @sort-change="sortChange"
        >
          <el-table-column :label="'ID'" prop="id" sortable="custom" align="center" width="80">
            <template slot-scope="{ row }">
              <span>{{ row.id }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'Email'" prop="email" align="left" width="250">
            <template slot-scope="{ row }">
              <span>{{ row.email }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'姓名'" prop="name" sortable="custom" align="center" width="200">
            <template slot-scope="{ row }">
              <span>{{ row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="建立時間" sortable="custom" width="200">
            <template slot-scope="{ row }">
              <span>{{ row.buildDate }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" :label="'操作'" width="200">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="primary"
                icon="el-icon-edit"
                @click="editData(scope.row)"
              >
                審核
              </el-button>
            </template>
          </el-table-column>

          <el-table-column align="center" :label="'刪除'" width="120">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="danger"
                icon="el-icon-key"
                @click="deleteData(scope.row)"
              >
                刪除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        style="padding-top: 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import { getTcRoles } from '@/api/member'
import waves from '@/directive/waves' // waves directive
import Pagination from '@/components/Pagination' // secondary package based on el-pagination
import Upload from '@/views/ita/components/fileUpload.vue'
import Tinymce from '@/components/Tinymce'
import {
  checkEmail,
  deleteBloggerApplication,
  getBloggerApplication,
  getIntroductionByEmail,
  getIntroductionTypeList,
  saveIntroduction,
  saveVerifyData,
  sendEmail,
} from '@/api/tcSetting'

var defaultIntroductionFormData = {
  id: null,
  authorName: '',
  introduction: '',
  sort: 99,
  socialLinkList: [],
  fileInfo: [],
}
export default {
  name: 'BloggerApplication',
  components: { Pagination, Upload, Tinymce },
  directives: { waves },
  data() {
    return {
      isOk: true,
      introRules: {
        authorName: [{ required: true, message: '請輸入名稱', trigger: 'blur' }],
        introduction: [{ required: true, message: '請輸入簡介', trigger: 'blur' }],
      },
      fileObj: { id: 0, type: 'agencyInfo', user: '' },
      formLabelWidth: '120px',
      dialogMemberFormVisible: false,
      rolesSelected: [],
      roleSettingObj: {
        roles: '',
      },
      introObj: {},
      rolesList: [],
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 30,
        sort: '-UpdateTime',
      },
      socialLinkSelectList: [],
      selectedUser: null,
      active: 0,
      verifyResult: false,
      newp: null,
      emailContent: '',
    }
  },
  async created() {
    await this.getIntroSelectType()
    this.getRoles()
    await this.getList()
  },
  methods: {
    next() {
      if (this.active++ > 3) {
        this.active = 0
      }
    },
    verify(value) {
      this.verifyResult = value
      if (!value) {
        this.active = 3
      } else {
        this.next()
      }
    },
    async getIntroSelectType() {
      this.socialLinkSelectList = await getIntroductionTypeList()
    },
    getRoles() {
      getTcRoles().then(response => {
        this.rolesList = response.data
      })
    },
    loadingHanlder(action) {
      let vm = this
      if (vm.listLoading != action) {
        vm.listLoading = action
      }
    },
    closeDialog() {
      this.isOk = true
      this.rolesSelected = []
      this.roleSettingObj = {}
      this.emailContent = ''
      this.verifyResult = false
      this.selectedUser = null
      this.newp = null
      if (this.$refs['tinymce'] !== undefined && this.$refs['tinymce'] !== null) {
        this.$refs['tinymce'].setValue('')
      }
      if (this.$refs['uploadRef'] !== undefined && this.$refs['uploadRef'] !== null) {
        let refUpload = this.$refs['uploadRef']
        refUpload.clearFiles()
        this.$refs['introductionForm'].clearValidate()
        this.introObj = JSON.parse(JSON.stringify(defaultIntroductionFormData))
      }
      this.dialogMemberFormVisible = false
      this.active = 0
    },
    async editData(row) {
      let vm = this
      var result = await checkEmail(row)
      vm.isOk = result.data.length == 0
      vm.rolesSelected = result.data
      vm.roleSettingObj = row
      vm.roleSettingObj.roles = result.data.toString()
      vm.dialogMemberFormVisible = true
    },
    saveData() {
      if (this.rolesSelected.length == 0) {
        this.$message.error('請選擇角色')
        return false
      }
      if (
        this.rolesSelected.indexOf('TC-USER') == -1 &&
        this.rolesSelected.indexOf('TC-TRAVEL-LEADER') == -1
      ) {
        this.$message.error('必須包含 TC-USER 或 TC-TRAVEL-LEADER 角色')
        return false
      }
      if (
        this.rolesSelected.indexOf('TC-USER') !== -1 &&
        this.rolesSelected.indexOf('TC-TRAVEL-LEADER') !== -1
      ) {
        this.$message.error('一般使用者與領隊角色只能二選一')
        return false
      }
      this.loadingHanlder(true)
      saveVerifyData({
        name: this.roleSettingObj.name,
        account: this.roleSettingObj.email,
        roles: this.rolesSelected,
      })
        .then(async response => {
          console.log(response)
          this.loadingHanlder(false)
          this.$message({
            message: '操作成功',
            type: 'success',
          })
          this.newp = response.data.pwd
          this.selectedUser = response.data.id
          await this.editIntroductionInfo()
          this.next()
        })
        .catch(error => {
          console.log(error.response.data)
          this.loadingHanlder(false)
        })
    },
    async deleteData(row) {
      let vm = this
      if (confirm(`確定刪除該筆駐站申請?\r\n`)) {
        vm.$message({
          message: '操作成功',
          type: 'success',
        })
        vm.listLoading = true
        let resp = await deleteBloggerApplication({ id: row.id })
        if (resp.success) {
          await vm.getList()
          vm.$message({
            message: '操作成功',
            type: 'success',
          })
        }
        vm.listLoading = false
      }
    },
    async editIntroductionInfo() {
      //透過api取得
      let vm = this
      vm.listLoading = true
      await getIntroductionByEmail({ email: this.roleSettingObj.email })
        .then(response => {
          console.log(response)
          if (response.data == null) {
            vm.introObj = JSON.parse(JSON.stringify(defaultIntroductionFormData))
          } else {
            vm.introObj = JSON.parse(JSON.stringify(response.data))
          }
          vm.listLoading = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    saveIntroduction(formName) {
      if (!confirm('確定儲存資料?')) {
        return
      }
      let vm = this
      let refUpload = this.$refs['uploadRef']
      this.$refs[formName].validate(async valid => {
        if (valid) {
          vm.loadingHanlder(true)
          let payload = await refUpload.combineFileAndPayload()
          if (!payload) {
            alert('檔案繫結表單發生未知錯誤，無法儲存資料。')
            return false
          }
          console.log(payload)
          payload.bindUser = vm.selectedUser
          await saveIntroduction(payload)
            .then(response => {
              vm.onDialogClosed()
              vm.loadingHanlder(false)
              this.$message({
                message: '操作成功',
                type: 'success',
              })
              this.next()
            })
            .catch(error => {})
        }
      })
    },
    async saveEmail() {
      this.loadingHanlder(true)
      await sendEmail({
        email: this.roleSettingObj.email,
        content: this.emailContent,
      })
        .then(response => {
          console.log(response)
          this.loadingHanlder(false)
          this.$message({
            message: '操作成功',
            type: 'success',
          })
          this.closeDialog()
        })
        .catch(error => {})
    },
    addSocialLink() {
      this.introObj.socialLinkList.push({
        id: null,
        socialType: 1,
        url: '',
      })
    },
    removeSocialLink(item) {
      var index = this.introObj.socialLinkList.indexOf(item)
      if (index !== -1) {
        this.introObj.socialLinkList.splice(index, 1)
      }
    },
    async getList() {
      this.loadingHanlder(true)
      var res = await getBloggerApplication(this.listQuery)
      this.list = res.data.data
      this.total = res.data.totalItemCount
      this.loadingHanlder(false)
    },
    onDialogClosed() {
      let refUpload = this.$refs['uploadRef']
      refUpload.clearFiles()
      this.$refs['introductionForm'].clearValidate()
      this.introObj = JSON.parse(JSON.stringify(defaultIntroductionFormData))
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    sortChange(data) {
      const { prop, order } = data
      this.sortByColumn(prop, order)
    },
    sortByColumn(sort, order) {
      if (order === 'ascending') {
        this.listQuery.sort = `+${sort}`
      } else if (order === 'descending') {
        this.listQuery.sort = `-${sort}`
      } else {
        const s = this.listQuery.sort[0]
        if (s === '+') {
          this.listQuery.sort = `-${sort}`
        } else if (s === '-') {
          this.listQuery.sort = `+${sort}`
        } else {
          this.listQuery.sort = `+${sort}`
        }
      }
      this.handleFilter()
    },
  },
}
</script>
<style scope>
.full-height {
  position: relative;
  height: 100%;
}
</style>
